import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  getEffectiveShipmentSummaryBase,
  primaryCarrierShipment,
} from "@redotech/redo-fulfillment-group-common/shipment-summary";
import { formatDateString } from "./fulfillment-group-csv-utils";

export const LabelPurchasedAtCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Label purchased at",
    cell: (row) => {
      return formatDateString(
        primaryCarrierShipment(
          getEffectiveShipmentSummaryBase(row),
        )?.purchasedAt?.toISOString() ?? "",
      );
    },
  };
